module.exports = __webpack_public_path__ + "img/location-big-blue.d2a17637.svg";